import React from 'react';

class UpgradeMembershipError extends React.Component {
  render() {
    return (
      <div className='confirmation-container flex-column align-center flex-center'>
        <img
          src={require('../../images/error.png')}
          className='error-img'
        />

        <div className='confirmation-text'>
          Uh oh. Looks like an error occured while trying to upgrade your membership.
        </div>

        <div className='confirmation-text'>
          Please email with support@trybe.do for assistance so we can help you finish upgrading your membership.
        </div>
      </div>
    );
  }
}

UpgradeMembershipError.displayName = 'UpgradeMembershipError';

export default UpgradeMembershipError;



// WEBPACK FOOTER //
// ./src/components/payments/UpgradeMembershipError.js